import classes from './hero.module.css';
import sessionPhoto from '../../assets/images/session-tutor-student.jpg';

const Hero = () => {
    return (
        <section className={classes.hero} aria-labelledby="hero-title">
            <div className={classes.grain} aria-hidden="true" />

            <div className={classes.inner}>
                <div className={classes.copy}>
                    <p className={`eyebrow ${classes.eyebrow} rise`}>PrepAnywhere</p>

                    <h1 id="hero-title" className={`${classes.title} rise`}>
                        Watching is not
                        <br />
                        <em className={classes.em}>learning.</em>
                    </h1>

                    <p className={`${classes.lede} rise`}>
                        A student watching a perfect explanation is still a student who
                        hasn't solved anything. We build for the opposite — the pen moving,
                        the struggle happening, and a teacher with the time to notice both.
                    </p>

                    <div className={`${classes.meta} rise`}>
                        <a className={classes.cta} href="#belief">
                            What we changed our mind about
                        </a>
                        <span className={classes.metaNote}>
                            PrepBox · PrepBoxPro · MathPulse
                        </span>
                    </div>
                </div>

                <figure className={`${classes.figure} rise`}>
                    <div className={classes.frame}>
                        <img
                            className={classes.photo}
                            src={sessionPhoto}
                            width="1400"
                            height="943"
                            alt="A student works a math problem on a tablet with a stylus while a tutor beside them leans in, mid-question."
                        />
                    </div>

                    <figcaption className={classes.figNote}>
                        The pen has slowed. The question that comes next is the whole job.
                    </figcaption>
                </figure>
            </div>
        </section>
    );
};

export default Hero;
